var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user.isAdmin
    ? _c("div", [
        _c("div", { staticClass: "flex flex-wrap flex-col md:flex-row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-full md:w-1/2 md:text-right mb-5 md:mb-0" },
            [
              _c(
                "router-link",
                {
                  staticClass: "button mb-2",
                  attrs: { to: "/festivals/create" },
                },
                [_vm._v("Create Festival")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "table",
          { staticClass: "w-full" },
          [
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.filteredFestivals, function (festival) {
              return _c("festival-item", {
                key: festival.id,
                attrs: { festival: festival },
              })
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex mt-8" }, [
          _c("div", { staticClass: "w-1/2" }, [
            _c(
              "button",
              {
                staticClass: "mt-2",
                class: {
                  "opacity-50 cursor-not-allowed": _vm.currentPage === 1,
                },
                attrs: { disabled: _vm.currentPage === 1 },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.previous.apply(null, arguments)
                  },
                },
              },
              [_vm._v("<< Previous")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-1/2 text-right" }, [
            _c(
              "button",
              {
                staticClass: "mt-2",
                class: {
                  "opacity-50 cursor-not-allowed":
                    _vm.currentPage === _vm.totalPages,
                },
                attrs: { disabled: _vm.currentPage === _vm.totalPages },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.next.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Next >>")]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-full md:w-1/2" }, [
      _c(
        "h1",
        { staticClass: "mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark" },
        [_vm._v("Festivals")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Slug")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }